import loadable from "@loadable/component";
import "ol/ol.css";
import "rlayers/control/layers.css";
import Spinner from "../components/Reusable/Spinner";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../customHooks/useDebounceHook";
const MapComponent = loadable(() => import("../components/Map"));
const Map = () => {
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debouncesearch = useDebounce(searchQuery);
  const { data: riderCoordinates, isLoading } = useGetHook({
    queryKey: [`rider-location-${debouncesearch}`],
    url: `${APIS.DRIVER}get-coordinate/`,
    params: {
      search:debouncesearch
    },
    interval: 20000,
  });

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <MapComponent riderCoordinates={riderCoordinates} />
      )}
    </>
  );
};

export default Map;
